import { SquareCircleIcon } from './SquareCircleIcon';

/**
 * author: Michael Irigoyen
 * id F49668FC-6B0F-43E9-BB4E-044C3C9229AA
 * name square-circle
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-circle.svg
 * tags
 * - Food / Drink 
 */
export const LactoVegetarianIcon = SquareCircleIcon;
export default LactoVegetarianIcon